/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExtendQuoteValidityRequest
 */
export interface ExtendQuoteValidityRequest {
    /**
     * 
     * @type {string}
     * @memberof ExtendQuoteValidityRequest
     */
    adminComment?: string;
}

/**
 * Check if a given object implements the ExtendQuoteValidityRequest interface.
 */
export function instanceOfExtendQuoteValidityRequest(value: object): value is ExtendQuoteValidityRequest {
    return true;
}

export function ExtendQuoteValidityRequestFromJSON(json: any): ExtendQuoteValidityRequest {
    return ExtendQuoteValidityRequestFromJSONTyped(json, false);
}

export function ExtendQuoteValidityRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtendQuoteValidityRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'adminComment': json['adminComment'] == null ? undefined : json['adminComment'],
    };
}

export function ExtendQuoteValidityRequestToJSON(value?: ExtendQuoteValidityRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'adminComment': value['adminComment'],
    };
}

